import React, { useState } from "react";
import { Card, Row, Col } from "antd";
import ProductionWindowCard from "./ProductionWindowChart";
import ProductionLinuxChart from "./ProductionLinuxChart";
import DrawerPlat from "../../../properties/Drawer/DrawerPlat";
import PatchManagementtable from "./PatchManagementtable";
import { useEffect } from "react";
import { Icon } from "@iconify/react";

const ProductionCard = (props) => {

  const tablerecords = props.prodlist
  const [drawerStatus, setDrawerStatus] = useState(false);
  const [deletestatus, setDeleteStatus] = useState(false);
  const [productionFilter, setProductionFilter] = useState(false);
  const [nonProductionFilter, setNonProductionFilter] = useState(false);
  const [prodlist, setprodlist] = useState([])
  const [nonprodlist, setnonprodlist] = useState([])
  useEffect(() => {
    const patchRecords = tablerecords.filter(
      (record) =>
        record.operating_system.toLowerCase() === "linux"

    );
    setprodlist(patchRecords);
    const patchRecords2 = tablerecords.filter(
      (record) =>
        record.operating_system.toLowerCase() === "windows"

    );
    setnonprodlist(patchRecords2);
  }, [tablerecords])

  const prodlistlength = prodlist.length;


  const changeDrawerStatus = () => {
    setDrawerStatus(false);
  };

  const handleIconClick = () => {
    setDrawerStatus(true);
    setProductionFilter(true);
    setNonProductionFilter(false);
  };

  return (
    <>

      <h6 className = "mt-2" style={{ color: 'white' }}>Production</h6>

      <Card className="plat-card-1">
        <>
          <DrawerPlat
            drawerstatus={drawerStatus}
            changeDrawerStatus={changeDrawerStatus}
            deletestatus={deletestatus}
            title="Patch Management"
          >
            <div>
              {" "}
              <PatchManagementtable
                refreshData={props.refreshData}
                productionFilter={productionFilter}
                nonProductionFilter={nonProductionFilter}
              />
            </div>
          </DrawerPlat>
          <div id="chart">
            
            
            <Row gutter={[16, 16]}>
              <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                <ProductionWindowCard countsos={props.countsos} nonprodlist={nonprodlist} />
              </Col>
              <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                <ProductionLinuxChart countsos={props.countsos} prodlist={prodlist} />
              </Col>
            </Row>

          </div>
          <div className="text-center">
            <span className="text-white">
              <span className="compliance-dot"></span> Compliance
            </span>
            &nbsp;
            <span className="text-white">
              {" "}
              <span className="non-compliance-dot"></span>Non Compliance
            </span>
          </div>
          
        </>
      </Card>
      
    </>
  );
};

export default ProductionCard;
